// i18n namespace "proof" (WP-A). The years figure is rendered from
// combinedYears() as "{{years}}+" in JSX, never written as a literal here.

export const en = {
  ariaLabel: "At a glance",
  clientsLabel: "Clients include",
  yearsLabel: "years of combined SAP experience",
  marketsLabel: "Where we work",
  markets: "Mexico · United States",
};

export const es = {
  ariaLabel: "En resumen",
  clientsLabel: "Algunos clientes",
  yearsLabel: "años de experiencia combinada en SAP",
  marketsLabel: "Dónde trabajamos",
  markets: "México · Estados Unidos",
};

export const fr = {
  ariaLabel: "En bref",
  clientsLabel: "Parmi nos clients",
  yearsLabel: "ans d’expérience SAP cumulée",
  marketsLabel: "Où nous intervenons",
  markets: "Mexique · États-Unis",
};

export const pt = {
  ariaLabel: "Em resumo",
  clientsLabel: "Alguns clientes",
  yearsLabel: "anos de experiência somada em SAP",
  marketsLabel: "Onde atuamos",
  markets: "México · Estados Unidos",
};
